import React from 'react'

import LoadingIndicator from 'components/LoadingIndicator'
import { DeliveryLinkageFeatureOffNotice } from 'components/DeliveryLinkageFeatureOffNotice'

import type { DeliveryPerformanceListControllerReturn } from '../hooks/useDeliveryPerformanceListController'
import { PerformanceFilterBar } from './PerformanceFilterBar'
import { PerformanceTable } from './PerformanceTable'
import styles from '../style.module.css'

type Props = DeliveryPerformanceListControllerReturn

export const DeliveryPerformanceListView: React.FC<Props> = ({
  shipments,
  total,
  totalPage,
  perPage,
  currentPage,
  isLoading,
  isTenantSettingsLoading,
  isError,
  isFeatureOff,
  filter,
  masterData,
  handleFilterChange,
  handleSearch,
  handlePageChange,
  handleRowClick,
}) => {
  // テナント設定取得中はフィルターバーを出さない（区分ON/OFFが確定するまで）
  // こうしないと区分OFFのテナントから切り替えたときにフィルターバーが一瞬フラッシュする
  if (isTenantSettingsLoading) {
    return (
      <div className={styles.page}>
        <div className={styles.header}>
          <h1 className={styles.title}>納品実績一覧</h1>
        </div>
        <div className={styles.content}>
          <LoadingIndicator />
        </div>
      </div>
    )
  }

  if (isFeatureOff) {
    return (
      <div className={styles.page}>
        <div className={styles.header}>
          <h1 className={styles.title}>納品実績一覧</h1>
        </div>
        <DeliveryLinkageFeatureOffNotice />
      </div>
    )
  }

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <h1 className={styles.title}>納品実績一覧</h1>
      </div>

      <PerformanceFilterBar
        filter={filter}
        total={total}
        totalPage={totalPage}
        currentPage={currentPage}
        perPage={perPage}
        onFilterChange={handleFilterChange}
        onSearch={handleSearch}
        onPageChange={handlePageChange}
      />

      <div className={styles.content}>
        {isLoading && <LoadingIndicator />}

        {!isLoading && isError && <div className={styles.errorState}>読み込みに失敗しました</div>}

        {!isLoading && !isError && (
          <PerformanceTable
            shipments={shipments}
            onRowClick={handleRowClick}
            maxHeight="calc((var(--vh, 1vh) * 100) - 176px)"
            masterData={masterData}
          />
        )}
      </div>
    </div>
  )
}
